import React from "react";
import Typewriter from "typewriter-effect";

function HomePage() {
  return (
    <section className="section-home" id="about">
      <div className="section-home__detail">
        <h3 className="heading-secondary">
          {" "}
          <span className="heading-secondary--color ">Hello,</span> Im Rohan
          Kumar.
        </h3>

        <h4 className=" heading-primary heading-primary--main u-margin-bottom-small">
          <Typewriter
            options={{
              strings: ["Frontend Engineer", "Software Developer", "Fullstack Developer"],
              autoStart: true,
              loop: true,
            }}
          />
        </h4>
        <p className="heading-tertiary heading-tertiary--main u-margin-bottom-medium">
          I am currently employed at SigSAIL Pvt Ltd and seeking a Full Stack or
          Frontend Developer role. I have extensive hands-on experience with
          technologies like ReactJS, VueJS, NodeJS, Django, Flask, MongoDB,
          PostgreSQL, AWS, Google Cloud, and local server environments.
        </p>
        <a
          className="btn-primary u-margin-right-small"
          href="https://drive.google.com/drive/folders/1Y2jw6aGyRA7D6toINasCVVZomzLdLLlb?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          Download CV
        </a>
        <a className="btn-secondary" href="#contact">
          Hire Me{" "}
        </a>
      </div>
      <div className="section-home__image-box">
        <img
          className="section-home__image"
          src="./profile.png"
          alt="Profile"
        />
        <div className="section-home__overlay-box">
          <div className="section-home__overlay-icon">
            <img
              className="section-home__overlay-icon__image "
              src="./icons/star.svg"
              alt="Star"
            />
          </div>
          <div className="section-home__overlay-text">Experienced</div>
        </div>
        <div className="section-home__overlay-box-2">
          <div className="section-home__overlay-icon">
            <img
              className="section-home__overlay-icon__image time-icon"
              src="./icons/clock.svg"
              alt="Time"
            />
          </div>
          <div className="section-home__overlay-text">Multitasking</div>
        </div>
      </div>
    </section>
  );
}

export default HomePage;
